import SponsorHeader from '../../../components/sponsor-header';
import { TImprovedContentMarketing } from '../../../../../../shared/types/contentMarketing';
import * as React from 'react';
import VerticalBlock from '../../../blocks/vertical-block';
import NonCardAnchorWrapper from '../../../components/non-card-anchor-wrapper';
import LineSvg from '../../../assets/line-svg';

type TCarResult = {
    contentMarketing: TImprovedContentMarketing;
    isMultipleAds: boolean;
};
const CarResultSingle = ({ contentMarketing }: TCarResult) => {
    return (
        <>
            <SponsorHeader contentMarketing={contentMarketing} />
            <NonCardAnchorWrapper href={contentMarketing.href}>
                <VerticalBlock
                    hasImageRadius={true}
                    noPadding={true}
                    contentMarketing={contentMarketing}
                    isMultipleAds={false}
                />
            </NonCardAnchorWrapper>
            <LineSvg />
        </>
    );
};

export default CarResultSingle;
